// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"589":"9c09f9fc","718":"6457f9c8"}[chunkId] + ".chunk.js";
};